import React from "react";
import { useTranslation } from "react-i18next";
import { Text, View } from "@/styles/reactnative";

interface IProps {
  title?: any;
}
const MarketTrendHeader = ({ title }: IProps) => {
  const { t } = useTranslation();
  return (
    <View
      style={{
        alignItems: "flex-start",
        marginBottom: 14,
        marginTop: 10,
        paddingLeft: 10,
      }}
    >
      <Text size={16} style={{ fontWeight: "600" }}>
        {t(title)}
      </Text>
    </View>
  );
};

export default React.memo(MarketTrendHeader);
